
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noticias/autor/[author]",
      function () {
        return require("private-next-pages/noticias/autor/[author].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/noticias/autor/[author]"])
      });
    }
  